import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
/** PERSONAL */
import Stem from './Stem';
import Footer from '../Footer';
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Exercise extends Component {
    constructor(props) {
        super(props);
        
        const visible = props.showAnswer ? true : false;

        this.state = {
            visible: 1||visible,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQLoad();
        if (this.props.showAllAnswer) {
            this.toggleAnswer(this.props.showAllAnswer)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.MQLoad();
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    // 显示答案
    toggleAnswer = (val) => {
        this.setState({ visible: val });

        const { answer } = this.state.data;
        const blanks = $(findDOMNode(this)).find(`span[data-id]`);
        if (val) {
            blanks.each(function () {
                const id = $(this).attr('data-id');
                $(this).html(answer[id].split('|')[0]);
            });
        } else {
            blanks.html('');
        }
    };

    // 导出题目
    handleExport = () => {
        const { handleExport } = this.props;
        handleExport && handleExport();
    };

    // 获取替换题目列表
    getReplaceQuestion = () => {
        const { getReplaceQuestion } = this.props;
        getReplaceQuestion && getReplaceQuestion();
    };

    // 更换题目
    handleReplace = () => {
        const { handleReplace } = this.props;
        handleReplace && handleReplace();
    };

    render() {
        const { visible, data } = this.state;
        const { stem } = data;
        const { num, canShowAnswer, canExport, canRelpace, handleReplace, exported } = this.props;
        const classname = classnames('question-wrapper', 'question-vertical', {
            'exported': exported
        });

        return (
            <div className={classname} ref={(el) => this.viewer = el}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text">
                            <span>{`${num + 1}.`}</span>
                        </p>
                    </div>
                    <div className="question-stem"><Stem stem={stem} /></div>
                </div>
                <div className="question-footer">
                    <div className="footer-show">
                        <Footer {...this.props}>
                            {
                                canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible, e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }
                            {
                                canExport ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleExport}>
                                        {!exported ? '选择' : '取消'}
                                    </button> : null
                            }
                            {
                                canRelpace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.getReplaceQuestion}>更换此题</button> : null
                            }
                            {
                                handleReplace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleReplace}>选择</button> : null
                            }
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Exercise;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/vertical/view.js